import BaseModel from '../base/BaseModel.model';
import { CurriculumSource } from '@/enums/curriculumSource';
export default class ReferenceUser extends BaseModel {
    public userId?: number;
    public fullName?: string;
    public organization?:string;
    public position?: string;
    public phoneNumber?:string;

    constructor(){
        super();
        this.init();
    }

    init(){ 
        this.userId = undefined;
        this.fullName = "";
        this.position = "";
        this.organization =  "";
        this.phoneNumber = "";
    }
}